import { useMutation } from 'react-query'
import { NestAPI, useGetBusiness } from '@marketing-milk/frontend'
import {
  CreativeImportConfirmRequest,
  CreativeImportConfirmResponse,
} from '@marketing-milk/interfaces'

/**
 * Confirms selected rows for import — the call with the Facebook side effect.
 * A 409 means the job was already confirmed (double-click/second tab); callers
 * treat it as success and proceed to polling.
 */
export const useCreativeImportConfirm = () => {
  const business = useGetBusiness()

  return useMutation(
    async (input: {
      creativeImportID: number
      request: CreativeImportConfirmRequest
    }): Promise<CreativeImportConfirmResponse> => {
      const response = await NestAPI.post<CreativeImportConfirmResponse>(
        `businesses/${business.id}/creative-import/${input.creativeImportID}/confirm`,
        input.request
      )
      return response.data
    }
  )
}
